import { SubmitButton } from 'components/common/buttons/SubmitButton';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Select, selectCustomStyles } from './Select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchVendors } from 'slices/vendorSlice';
import { CheckinCheckout } from 'components/ScheduleForm';
import { CheckinDateTimeInputs } from 'components/ScheduleForm';
import { CheckoutDateTimeInputs } from 'components/ScheduleForm';
import { CommentsAndNotes } from 'components/ScheduleForm';
import { fetchTranslators } from 'slices/inviteTranslatorSlice';
import { inviteTranslatorsSelector } from 'slices/inviteTranslatorSlice';
import { MultiSelect } from './MultiSelect';
import CustomMultiSelect from './CustomMultiSelect';

function SelectTranslatorModal({
    isOpen,
    onClose,
    onConfirm,
    item,
    loader,
    isReassign = false,
}) {

    const dispatch = useDispatch();
    const methods = useForm({
        defaultValues: {
            interpreter_id: []
        }
    });
    const { inviteTranslators, last_page: totalPages, loader: translatorsLoader, allTranslators } = useSelector(inviteTranslatorsSelector);
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors, } = methods

    const filteredInterpreters = React.useMemo(() => {
        return allTranslators?.map(item => ({
            label: item?.user?.name,
            value: item?.id,
        })) || [];
    }, [allTranslators]);

    useEffect(() => {

        isOpen &&
            dispatch(fetchTranslators(item?.id));

    }, [isOpen])

    useEffect(() => {
        if (isOpen && item?.interpreter_id && filteredInterpreters.length > 0) {
            const matched = filteredInterpreters.find(f => f.value == item.interpreter_id);
            if (matched) {
                setValue("interpreter_id", matched.value);
            }
        } else if (isOpen && !item?.interpreter_id) {
            setValue("interpreter_id", null);
        }
    }, [isOpen, item?.interpreter_id, filteredInterpreters, setValue])



    const isInterpreter = useMemo(() => {
        return watch('interpreter_id') ? true : false
    }, [watch('interpreter_id'), isOpen])


    // #region Interpreter Dropdown 
    // const [ed, setFilterInterpreters] = useState({
    //     label: "",
    //     value: ""
    // })

    // useEffect(() => {
    //     if (allTranslators?.user?.name && allTranslators?.id) {
    //         setFilterInterpreters({
    //             label: allTranslators?.user?.name || "",
    //             value: allTranslators?.id || ""
    //         })
    //     } else {
    //         setFilterInterpreters(null)
    //     }
    // }, [allTranslators])




    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <FormProvider {...methods}>
                    <form action="" onSubmit={handleSubmit((data) => onConfirm(data?.interpreter_id, isReassign))}>
                        <ModalHeader className='header_modal align-items-center'>
                            <h5 className="modal-title_u">{isReassign ? "Reassign" : "Assign"}</h5>
                        </ModalHeader>
                        <ModalBody className='modal_form_body'>
                            <div
                             style={{ backgroundColor: "#F2F2F2", padding: "20px", borderRadius: "14px", height: "auto"}}
                            className=' step_1'>
                                {/* INTERPRETER SELECT */}
                                <div
                                className="row-primary">
                                    <h2>Vendor</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="interpreter_id"
                                            control={control}
                                            render={({ field }) =>
                                                <div style={{ width: "100%" }}>
                                                    <Select
                                                        menuPlacement='auto'
                                                        styles={{ ...selectCustomStyles }}
                                                        value={filteredInterpreters.find(f => f.value == field.value)}
                                                        options={filteredInterpreters}
                                                        isClearable
                                                        onChange={(obj) => {
                                                            if (obj) {
                                                                field.onChange(obj);
                                                            } else {
                                                                field.onChange(null);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>

                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <SubmitButton 
                                btnText={loader ? (isReassign ? "Reassigning..." : "Assigning...") : (isReassign ? "Reassign" : "Assign")} 
                                loader={loader} 
                                disabled={loader} 
                            />
                            <button className="table_delete" type='button' onClick={onClose} disabled={loader}>Cancel</button>
                        </ModalFooter>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default SelectTranslatorModal;